import i18n from "i18n-js";

import en from "./en.json";
import fr from "./fr.json";
import de from "./de.json";
import es from "./es.json";
import detectBrowserLanguage from "detect-browser-language";

i18n.locale = detectBrowserLanguage();
i18n.fallbacks = true;
i18n.translations = { en, fr, de, es };

export default function(
  key: string,
  variables?: { [variableName: string]: string }
): string {
  return i18n.t(key, variables);
}



// WEBPACK FOOTER //
// ./src/translations/i18n.ts